"use client";

import { cn } from "@oreme/ui";
import { cva } from "class-variance-authority";
import type { LngLatLike, Map as MapLibre, MapLibreEvent } from "maplibre-gl";
import { RMap, RNavigationControl } from "maplibre-react-components";
import React, { ReactElement, useState, useRef } from "react";
import { SitesMapLayerList, SitesControlRight, SitesTour } from "@/components";
import { useMapLibre } from "@/hooks";

const sitesMapVariants = cva("", {
  variants: {
    loaded: {
      true: "animate__animated animate__fadeIn animate__faster",
      false: "hidden",
    },
  },
  defaultVariants: {
    loaded: false,
  },
});

function SitesMap(): ReactElement | null {
  const { init, tile } = useMapLibre();
  const mapRef = useRef<MapLibre>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const center: LngLatLike = [3.8593521385608796, 43.62179360643451];

  const handleLoad = (e: MapLibreEvent) => {
    init(e.target);
    setIsLoaded(true);
  };

  if (!tile?.url) return null;

  return (
    <RMap
      className={cn(sitesMapVariants({ loaded: isLoaded }))}
      id="map"
      initialCanvasContextAttributes={{ antialias: true }}
      initialCenter={center}
      initialZoom={2}
      mapStyle={tile.url}
      ref={mapRef}
      initialAttributionControl={false}
      onLoad={handleLoad}
    >
      <RNavigationControl position="top-right" visualizePitch />
      <SitesControlRight />
      <SitesMapLayerList />
      <SitesTour />
      <span
        id="tour-1"
        className="absolute top-1/2 right-1/4 w-0 h-0 sr-only"
      />
    </RMap>
  );
}

export { SitesMap };
